import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Grid,
  TextField,
  Button,
  Autocomplete,
  FormGroup,
  FormControlLabel,
  Checkbox,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { standardDate } from "../manager/dateManager";
import { getUser } from "../services/authService";

const EditModalDialog = ({
  dialogTitle,
  formSchema,
  updateModal,
  handleClose,
  roleMaster,
  onEdit,
}) => {
  const [updatedData, setUpdatedData] = useState({});
  const user = getUser();

  const handleChange = (event) => {
    setUpdatedData({
      ...updatedData,
      [event.target.name]: event.target.value,
    });
  };

  const handleCheckBox = (event) => {
    setUpdatedData({
      ...updatedData,
      IsMFA: event.target.checked,
    });
  };

  useEffect(() => {
    setUpdatedData(updateModal);
    return () => {
      setUpdatedData({});
    };
  }, [updateModal]);


  return (
    <Dialog fullWidth maxWidth={"sm"} open={updateModal} onClose={handleClose}>
      <DialogTitle>
        {dialogTitle}
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          pt: "16px !important",
        }}
      >
        <Grid container spacing={2}>
          {updatedData &&
            formSchema.map((current) => {
              if (current.type === "autocomplete") {
                return (
                  <Grid item lg={current.wdth} key={current.name}>
                    <Autocomplete
                      options={roleMaster}
                      getOptionLabel={(option) => option.RoleName}
                      fullWidth
                      name={current.name}
                      value={updatedData[current.name]}
                      defaultValue={{
                        [current.default.key]: updatedData[current.default.key],
                        [current.default.label]:
                          updatedData[current.default.label],
                      }}
                      onChange={(e, value) => {
                        setUpdatedData({
                          ...updatedData,
                          [current.name]: value,
                        });
                      }}
                      renderInput={(params) => (
                        <TextField {...params} label={current.label} />
                      )}
                    />
                  </Grid>
                );
              } else if (current.type === "checkbox" && user.isImpexAdmin) {
                return (
                  <>
                    <Grid item lg={6}>
                      <FormGroup sx={{ mt: 2 }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              defaultChecked={updatedData[current.name]}
                            />
                          }
                          id="IsMFA"
                          name="IsMFA"
                          label="Set MFA"
                          onChange={handleCheckBox}
                        />
                      </FormGroup>
                    </Grid>
                  </>
                );
              } else if (current.type === "options" && user.isImpexAdmin) {
                return (
                  <Grid item lg={6}>
                    <FormGroup>
                      <InputLabel id="MFADays">MFADays</InputLabel>
                      <Select
                        id="MFADays"
                        name="MFADays"
                        defaultValue={updatedData[current.name]}
                        label="MFADays"
                        onChange={handleChange}
                        fullWidth
                      >
                        {[1, 7, 15, 30, 45, 60].map((item, index) => {
                          return (
                            <MenuItem
                              key={index}
                              value={item}
                              selected={item === 0}
                            >
                              {item}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormGroup>
                  </Grid>
                );
              } else if (current.type === "text") {
                return (
                  <Grid item lg={current.wdth} key={current.name}>
                    <TextField
                      fullWidth
                      label={current.label}
                      value={
                        current.type === "date"
                          ? standardDate(updatedData[current.name])
                          : updatedData[current.name]
                      }
                      name={current.name}
                      onChange={handleChange}
                      type={current.type}
                      disabled={current.disabled}
                    />
                  </Grid>
                );
              } else {
                return (
                  <Grid item lg={current.wdth} key={current.name}>
                    <TextField
                      fullWidth
                      label={current.label}
                      value={
                        current.type === "date"
                          ? standardDate(updatedData[current.name])
                          : updatedData[current.name]
                      }
                      name={current.name}
                      onChange={handleChange}
                      type={current.type}
                      disabled={current.disabled}
                    />
                  </Grid>
                );
              }
            })}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            onEdit(updatedData);
          }}
          sx={{ marginRight: "20px", marginBottom: "20px" }}
          variant="contained"
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditModalDialog;
